import { Component, OnInit, ElementRef, ViewChild, Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../shared/services/auth.service';
import { ApiService } from '../shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { DatosDenuncia } from 'src/app/shared/models/datosDenuncia';
import { Testigo } from '../model/testigo';
import { Medida } from '../model/medida';
import { Documento } from '../model/documento';
import { DatePipe } from '@angular/common'
import { Comentario } from '../model/comentario';
import { FormControl, FormGroup } from "@angular/forms";
import { environment } from "../../environments/environment.prod"
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas'
import { Acciones } from '../model/acciones';
import { Rol } from '../model/rol';
import { SpinnerService } from '../services/spinner.service';
import { PeertopeerService } from '../shared/services/peertopeer.service';
import { ConfiguracionAvanzadaService } from '../dashboard/services/configuracion-avanzada.service';
import { Parametros } from '../model/parametros';
import { Apelaciones } from '../model/datosApelaciones';
import { DatosApelacion } from '../model/datosApelacion';
import { Response } from '../shared/models/response.model';
import { SafeResourceUrl } from '@angular/platform-browser';
import { FileUtilsService } from '../shared/services/file-utils.service';

declare var require: any
const FileSaver = require('file-saver');

@Injectable()
@Component({
  selector: 'app-editar-denuncia',
  templateUrl: './editar-denuncia.component.html',
  styleUrls: ['./editar-denuncia.component.css'],
  providers: [DatePipe]
})

export class EditarDenunciaComponent implements OnInit {
  assetsUrl: string = environment.baseAssetsUrl;
  validatingForm: FormGroup;
  pin_code: string;
  roles: Rol[];
  denuncia: DatosDenuncia[];
  apelaciones: Apelaciones;
  apelacionActual?: DatosApelacion;
  testigo: Testigo[];
  medida: Medida[];
  documento: Documento[];
  accion: Acciones[];
  bExisteAccion: boolean = false;
  isFinished: boolean = false;
  bExisteTestigo = true;
  bExisteMedida = true;
  bExisteDocumento = true;
  id: string;
  comentarios: Comentario[];
  avatar: string;
  showChat: boolean = false;
  sendChat: boolean = false;
  isReceptor: boolean = false;
  isDecisor: boolean = false;
  isInvestigador: boolean = false;
  isFaseInicial: boolean = false;
  isFaseExterno: boolean = false;
  isFaseDecisor: boolean = false;
  isFaseCompliance: boolean = false;
  progressBar: number = 0;
  isFaseInvestigador = false;
  backgroundColor: string = 'red';
  showDocument: boolean = false;
  idrole: string;
  sociedadUsuario: string;
  showButtonArchive: boolean = false; //show button archive complaint
  showCenter: boolean = false; //Variable para mostrar el campo centro en el HTML con valor TRUE OR FALSE
  showButtonChangeTypeComplaint: boolean = false; //button that show selected type complaint
  showButtonChangePhase: boolean = false; //button that show selected changed phase
  showCommentaryPhase: string; //show commentary from phase changed
  showDivFromCommentary: boolean = false; //show DIV where it show commentary
  consultaResultados: any; //Show Investigators from complaints
  isActiveIdPersonalizable: boolean = false; //Is Active Id Custom
  parametros: Parametros;
  linkDrive: string;
  showLinkDrive: boolean = false;
  isActiveDrive: boolean = false; //Is Active Cloud Storage
  isActiveFaseAppeals: boolean = false;
  isActiveCenter: string = '0';
  language: string = '';
  isLoading: boolean = false;
  url: SafeResourceUrl | null = null;
  showFile = false;
  mimeType: string | null = null;
  showPreviewInfo = true;

  @ViewChild('contenedor') contenedor: ElementRef;

  archivo: Documento[];

  //state of decisors array
  decisoresCount: number = 0;
  investigadoresCount: number = 0;

  constructor(
    private apiService: ApiService,
    private router: Router,
    private auth: AuthService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private actRoute: ActivatedRoute,
    private datepipe: DatePipe,
    private cryptoService: PeertopeerService,
    private spinnerSvc: SpinnerService,
    private configuracionAvanzadaService: ConfiguracionAvanzadaService,
    private fileUtilsService: FileUtilsService) { }

  ngOnInit() {
    this.initializeLanguage();
    this.initializeForm();
    this.initializeCenterFlags();
    this.initializeDriveConfig();
    this.initializeSocietyInfo();
    this.loadComplaintData();
  }

  private initializeLanguage(): void {
    this.language = this.auth.getLanguage() || 'es';
    this.translate.setDefaultLang(this.language);
  }
private initializeForm(): void {
    this.id = this.actRoute.snapshot.params.id;
    this.validatingForm = new FormGroup({
      comentarioDenuncia: new FormControl('')
    });
  }

  private initializeCenterFlags(): void {
    this.isActiveCenter = this.auth.getCentros() === '1' ? '1' : '0';
    this.showCenter = this.isActiveCenter === '1';
    this.isActiveIdPersonalizable = this.auth.getIdPersonalizable() === '1';
  }

  private initializeDriveConfig(): void {
    this.configuracionAvanzadaService
      .searchAdvancedParam(this.auth.getSociedad())
      .subscribe({
        next: (response) => {
          if (response.success && response.data && response.code === 200) {
            this.parametros = response.data;
            this.linkDrive = this.parametros[79]?.valor ?? '';
            this.isActiveDrive = this.parametros[80]?.valor === '1';
          } else {
            this.handleDriveError();
          }
        },
        error: () => this.handleDriveError()
      });
  }

  private handleDriveError(): void {
    this.toastr.error(this.translate.instant('texto_899'));
    this.linkDrive = '';
    this.isActiveDrive = false;
  }

  private initializeSocietyInfo(): void {
    this.sociedadUsuario = this.auth.getNameSociedad();
    this.avatar = environment.baseAvatar + "social.png";
  }

  private loadComplaintData(): void {
    this.isLoading = true;
    this.apiService.searchComplaintById(
      this.id,
      this.language,
      this.auth.getIdUser(),
      this.isActiveCenter,
      this.isActiveIdPersonalizable,
      'gestor'
    ).subscribe({
      next: (denuncia) => {
        if (denuncia.code === 200 && denuncia.success) {
          this.handleComplaintResponse(denuncia);
        }
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
        this.toastr.error(
          this.translate.instant('texto_904'),
          this.translate.instant('texto_813')
        );
        this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true })
          .then(() => this.router.navigate(['dashboard/complaint-management/mis-denuncias']));
        return;
      }
    });
  }

  private handleComplaintResponse(denuncia: any): void {
    this.denuncia = denuncia.data;

    if (!this.denuncia || this.denuncia.length === 0) {
      this.toastr.error(
        this.translate.instant('texto_904'),
        this.translate.instant('texto_813')
      );
      this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true })
        .then(() => this.router.navigate(['dashboard/complaint-management/mis-denuncias']));
      return;
    }
    // Call loadUserRole and then loadAdditionalComplaintData as callback
    this.apiService.searchRoleByUserSociety('setUser', this.auth.getSociedad(), '1')
      .subscribe({
        next: (res) => {
          this.roles = res.data;
          const roleString = res.data.map(r => r.id_rol).join(',');
          this.setupUIBasedOnPhase(roleString);
          // Now call loadAdditionalComplaintData after roles are loaded
          this.loadAdditionalComplaintData();
        },
        error: (err) => {
          this.toastr.error(this.translate.instant('texto_915'), this.translate.instant('texto_813'));
        }
      });
  }

  private loadUserRole(): void {
    this.apiService.searchRoleByUserSociety('setUser', this.auth.getSociedad(), '1')
      .subscribe({
        next: (roles) => {
          if (roles.success && roles.code === 200) {
            this.roles = roles.data;
            const roleString = roles.data.map(r => r.id_rol).join(',');
            this.setupUIBasedOnPhase(roleString);
          }
        }, error: (err) => {
          this.toastr.error(this.translate.instant('texto_915'), this.translate.instant('texto_813'));
          //* opcional * Se puede redirigir a las denuncias si falla
        }
      });
  }

  private setupUIBasedOnPhase(role: string): void {
    const fase = this.denuncia[0].id_fase;
    switch (fase) {
      case "0":
        this.progressBar = 10;
        this.showChat = this.sendChat = true;
        if (role.includes("1")) {
          this.isFaseInicial = true;
          this.idrole = '1';
          this.showButtonChangeTypeComplaint = true;
        }
        break;

      case "12":
        this.backgroundColor = '#a6a5a5';
        this.progressBar = 100;
        this.showChat = this.sendChat = true;
        this.isActiveFaseAppeals = true;
        break;

      case "11":
        this.progressBar = 5;
        this.showChat = this.sendChat = true;
        if (role.includes("11")) {
          this.isFaseExterno = true;
          this.idrole = '11';
          this.showButtonChangeTypeComplaint = true;
        }
        break;

      case "1":
        this.progressBar = 25;
        this.showChat = this.sendChat = true;
        this.backgroundColor = 'red';
        this.isFaseInvestigador = true;
        this.idrole = '1';
        this.showButtonChangePhase = true;
        break;

      case "2":
        this.progressBar = 50;
        this.showChat = this.sendChat = true;
        this.idrole = '2';
        this.showButtonChangePhase = true;
        if (role.includes("2")) {
          this.isInvestigador = true;
          this.showDocument = true;
          if (this.isActiveDrive) this.showLinkDrive = true;
        }
        this.backgroundColor = '#F1C453';
        break;

      case "3":
        this.progressBar = 65;
        this.idrole = '1';
        this.showButtonChangePhase = true;
        this.isFaseDecisor = role.includes("1");
        this.backgroundColor = '#EFEA5A';
        this.sendChat = true;
        break;

      case "4":
        if (role.includes("3")) {
          this.isDecisor = true;
          this.isFaseDecisor = true;
          if (this.isActiveDrive) this.showLinkDrive = true;
        }
        this.progressBar = 75;
        this.backgroundColor = '#B9E769';
        this.showDocument = true;
        this.sendChat = false;
        this.isFaseDecisor = false;
        this.showButtonChangePhase = true;
        break;

      case "5":
        this.isFaseDecisor = false;
        this.isFaseCompliance = true;
        this.progressBar = 85;
        this.backgroundColor = '#83E377';
        this.showButtonChangePhase = true;
        if (role.includes("4") && this.isActiveDrive) this.showLinkDrive = true;
        break;

      case "6":
      case "7":
      case "8":
        this.progressBar = 100;
        this.backgroundColor = '#16DB93';
        this.isFinished = true;
        break;
    }
  }

  private loadAdditionalComplaintData(): void {
    this.apiService.searchCommentsByComplaint(this.id, false, 'gestor').subscribe({
      next: (response: Response<Comentario[]>) => {
        if (response.code === 200 && response.success) {
          this.comentarios = response.data || [];
          this.showChat = this.comentarios.length > 0;
        } else {
          this.comentarios = [];
          this.showChat = false;
        }
      }, error: (err) => {
        this.comentarios = [];
        this.showChat = false;
      }
    });

    this.apiService.showCommentaryPhaseChange(
      this.id,
      this.auth.getSociedad(),
      this.denuncia[0].id_fase
    ).subscribe((res) => {
      this.showCommentaryPhase = res;
      this.showDivFromCommentary = !!res;
    });

    this.apiService.searchWitnessByComplaint(this.id, this.idrole)
      .subscribe({
        next: (response) => {
          if (response.code === 200 && response.success) {
            this.testigo = response.data;
            this.bExisteTestigo = response.data.length > 0;
          } else {
            this.testigo = [];
            this.bExisteTestigo = false;
          }
        }, error: (err) => {
          if (err.error.code !== 404) {
            this.testigo = [];
          }
          this.testigo = [];
          this.bExisteTestigo = false;
        }
      });

    this.apiService.searchMedidaPorIdDenuncia(this.id)
      .subscribe({
        next: (medidas) => {
          this.medida = medidas.data;

          this.bExisteMedida = medidas.data.length > 0;
        }, error: (err) => {
          this.medida = [];
          this.bExisteMedida = false;
        }
      });

    this.apiService.FindUsersByReportID(this.id, this.auth.getSociedad())
      .subscribe((resultado: any) => this.consultaResultados = resultado);

    this.apiService.searchDocumentsByComplaint(this.id, true, this.idrole)
      .subscribe(res => {
        if (res.code === 200 && res.success) {
          this.documento = res.data;
          this.bExisteDocumento = this.documento.length > 0;
        } else {
          this.documento = [];
          this.bExisteDocumento = false;
        }
      }, err => {
        this.documento = [];
        this.bExisteDocumento = false;
      }
      );

    if (this.isFaseCompliance || this.isFinished) {
      this.apiService.searchActionsByComplaint(this.id)
        .subscribe({
          next: (response) => {
            if (response.code === 200 && response.success) {
              this.accion = response.data || [];
              this.bExisteAccion = !!response.data;
              if (this.isFinished) {
                this.bExisteAccion = false;
                this.showButtonArchive = true;
              }
            }
          },
          error: (error) => {
            this.accion = [];
            this.bExisteAccion = false;
            if (error.error.code !== 404) {
              this.toastr.error(this.translate.instant('texto_895'), this.translate.instant('texto_813'));
            }
          }
        });
    }

    this.apiService.getAppealsByComplaint(this.denuncia[0].id_denuncia, 'gestor')
      .subscribe({
        next: (response: Apelaciones) => this.apelaciones = response,
        error: () => this.toastr.error(this.translate.instant('texto_850'), this.translate.instant('texto_813'))
      });

    this.apiService.getCurrentAppealByComplaint(this.denuncia[0].id_denuncia)
      .subscribe({
        next: (response: DatosApelacion) => {
          if (!response.message) {
            this.apelacionActual = response;
          }
        }
      });
  }

  get comentarioDenuncia() {
    return this.validatingForm.get('comentarioDenuncia');
  }

  enviarMensaje(id_denuncia) {
    let date = new Date();
    let _date = this.datepipe.transform(date, 'yyyy-MM-dd HH:mm:ss');
    let comentario = this.comentarioDenuncia.value.replace(/<[^>]*>/g, '');

    if (comentario != null && comentario != "") {
      comentario = comentario.replace(/'/g, '');
      //encrypt data
      const encryIdSociedad = this.cryptoService.encryptData(this.denuncia[0].id_sociedad);
      const encryIdDenuncia = this.cryptoService.encryptData(String(id_denuncia));
      const encrytNombre = this.cryptoService.encryptData('setUser');
      const encryComentario = this.cryptoService.encryptData(comentario);
      const encryDate = this.cryptoService.encryptData(_date);
      const encryIdUsuarioIdentificador = this.cryptoService.encryptData('setUser');

      this.apiService.sendMessageChat(encryIdSociedad, encryIdDenuncia, encrytNombre, encryComentario, encryDate, encryIdUsuarioIdentificador, false).subscribe(
        res => {
          if (res == 200) {
            let $clau = false;
            let clausulas_correo = localStorage.getItem("clausulas_correo");
            if (clausulas_correo == '1') {
              $clau = true;
            }
            let idDenunciaMostrado; // Variable to store the complaint ID to be displayed
            // Check if isActiveIdPersonalizable is true
            if (this.isActiveIdPersonalizable) {
              // If true, use identificador_denuncia if it exists, otherwise use id_denuncia
              idDenunciaMostrado = this.denuncia[0].identificador_denuncia
                ? this.denuncia[0].identificador_denuncia
                : this.denuncia[0].id_denuncia;
            } else {
              // If isActiveIdPersonalizable is false, only use id_denuncia
              idDenunciaMostrado = this.denuncia[0].id_denuncia;
            }
            let url = environment.base + "/ver-denuncia/consultar-denuncia";
            let message = this.translate.instant('texto_576') + " " + this.denuncia[0].denunciante_nombre + " " + this.denuncia[0].denunciante_apellidos + this.translate.instant('texto_611') + " " + idDenunciaMostrado + this.translate.instant('texto_612');

            //console.log(this.denuncia[0].denunciante_correo)
            if (this.denuncia[0].denunciante_correo) {
              this.apiService.sendEmail(this.denuncia[0].denunciante_correo, this.translate.instant('texto_613') + idDenunciaMostrado, message, url, $clau, this.translate.instant('texto_613'), 'gestor').subscribe(
                res => {
                  if (res == 200) {
                    this.toastr.success(this.translate.instant('texto_194'), this.translate.instant('texto_195'));
                  } else {
                    this.toastr.error(this.translate.instant('texto_193'), this.translate.instant('texto_195'));
                  }
                });
            }
            this.toastr.success(this.translate.instant('texto_363'), this.translate.instant('texto_484'));
          } else {
            this.toastr.error(this.translate.instant('texto_29'), this.translate.instant('texto_484'));
          }
          this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
            this.router.navigate(['editar-denuncia/', this.id]);
          });
        });
    } else {
      this.toastr.error(this.translate.instant('texto_481'), this.translate.instant('texto_484'));
    }
  }

  /**
  * Exports the current complaint view to a PDF document.
  * If there are attached documents, prompts the user to download them as well.
  */
  exportarDocumento() {
    let ok = false;
    if (this.documento.length > 0) {
      if (confirm(this.translate.instant('texto_941'))) {
        ok = true;
      }
    }

    // Save original styles to restore later
    const panelChat = document.querySelector('.panel-body-chat') as HTMLElement;
    const originalOverflow = panelChat.style.overflowY;
    const originalHeight = panelChat.style.height;

    panelChat.style.overflowY = 'visible';
    panelChat.style.height = 'auto';

    // Hide buttons and other elements not to be printed
    const botonera = document.getElementById('botonera');
    botonera.style.display = 'none';

    const data = document.getElementById('contenedor');

    // Generate PDF
    html2canvas(data).then(canvas => {

      let HTML_Width = canvas.width;
      let HTML_Height = canvas.height;
      let top_left_margin = 0;

      let PDF_Width = HTML_Width
      let PDF_Height = (PDF_Width * (11 / 8.5))

      let totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1;

      let imgData = canvas.toDataURL("image/jpeg", 1.0);

      let pdf = new jspdf('p', 'pt', [PDF_Width, PDF_Height]);

      pdf.addImage(imgData, 'JPG',
        top_left_margin,
        top_left_margin,
        HTML_Width,
        HTML_Height
      );

      for (let i = 1; i <= totalPDFPages; i++) {
        pdf.addPage([PDF_Width, PDF_Height], 'p');
        pdf.addImage(
          imgData,
          'JPG',
          top_left_margin,
          -(PDF_Height * i),
          HTML_Width,
          HTML_Height
        );
      }

      let d = new Date().toISOString();
      pdf.save('report-' + d + '.pdf');

      // Download attached documents if user confirmed
      if (ok) {
        let idDenuncia = null;
        const ids = this.documento.map(doc => String(doc.id_archivo));
        if (this.isActiveIdPersonalizable) {
          idDenuncia = this.denuncia[0].identificador_denuncia ? this.denuncia[0].identificador_denuncia : this.denuncia[0].id_denuncia;
        } else {
          idDenuncia = this.denuncia[0].id_denuncia;
        }

        this.downloadDocumentsZip(ids, idDenuncia);
      }

      // Restore panel-body
      document.querySelectorAll('.panel-body').forEach((el: any) => {
        el.style.overflow = el.dataset._overflow;
        el.style.height = el.dataset._height;
      });

      document.querySelectorAll('.panel, .panel-body, .panel-heading')
        .forEach((el: any) => {
          el.style.border = el.dataset._border;
          delete el.dataset._border;
        });

      // Restore scroll
      panelChat.style.overflowY = originalOverflow;
      panelChat.style.height = originalHeight;

      document.querySelectorAll('*').forEach((el: any) => {
        if (el.dataset._overflow_force !== undefined) {
          el.style.overflow = el.dataset._overflow_force;
          delete el.dataset._overflow_force;
        }

        if (el.dataset._height_force !== undefined) {
          el.style.height = el.dataset._height_force;
          delete el.dataset._height_force;
        }
      });

      // Show buttons
      botonera.style.display = 'block';

    });
  }

  finalizarAccion(id_action: string) {
    this.apiService.updateActionsById(this.denuncia[0].id_denuncia, id_action).subscribe(
      res => {
        if (res.success && res.code === 200) {
          this.toastr.success(
            this.translate.instant('texto_283'),
            this.translate.instant('texto_285'),
          );
          this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
            this.router.navigate(['editar-denuncia/', this.denuncia[0].id_denuncia]);
          });
        }


      },
      error => {
        this.toastr.error(
          this.translate.instant('texto_284'),
          this.translate.instant('texto_813')
        );
      }
    );
  }

  /**
   * Checks if document preview is enabled in settings.
   * @returns boolean indicating if document preview is enabled.
   */
  isDocumentPreviewEnabled(): boolean {
    const documentPreview = this.auth.getDocumentPreview();
    return documentPreview === '1';
  }

  /**
   * Checks if the MIME type is previewable in the UI.
   * @param tipo_archivo The MIME type of the file.
   * @returns boolean indicating if the file type is previewable.
   */
  isVisualizable(tipo_archivo: string): boolean {
    return this.fileUtilsService.isVisualizable(tipo_archivo);
  }

  /**
   * Closes the preview information message.
   */
  closePreviewInfo(): void {
    this.showPreviewInfo = false;
  }

    /**
   * Downloads multiple documents as a ZIP file.
   */
  downloadDocumentsZip(ids: string[], id_denuncia: string) {
    this.fileUtilsService.downloadDocumentsZip(ids, id_denuncia);
  }

  /**
   * Downloads a file by its ID, name, and type.
   */
  downloadFile(id_archivo: number) {
    this.fileUtilsService.downloadFile(id_archivo, 'gestor');
  }

  /**
   * Displays a supported file type in an iframe viewer.
   */
  viewFile(id_archivo: number, tipo_archivo: string, n_archivo: string) {
    this.fileUtilsService.viewFile(id_archivo, tipo_archivo, n_archivo, 'gestor', (url, mimeType) => {
      this.url = url;
      this.mimeType = mimeType;
      this.showFile = true;
    });
  }

  openLinkDrive(): void {
    window.open(this.linkDrive, '_blank');
  }

  //Function that must call from son
  actualizarDecisores(count: number) {
    this.decisoresCount = count;
  }

  //Function that must call from son
  actualizarInvestigadores(count: number) {
    this.investigadoresCount = count;
  }

}
